export const TARIFFS_TRANSLATIONS_MAP = {
  realEstate: 'Страхование недвижимости',
  life: 'Страхование жизни',
}

export const GLOBAL_MODAL_KEYS_MAP = {
    successPolicyIssuance: 'payment_success',
}

export const INSURANCE_CARDS = [
    {
        tariff: 'property',
        title: TARIFFS_TRANSLATIONS_MAP.realEstate,
        subtitle: 'Страхование недвижимости и не только',
        price: '100 000',
        listItems: [
            {
                text: 'Премия',
                price: '2 500',
                tooltip: 'Конструктивные элементы помещения (площадью до 1 000м2) на сумму 200 000 ₽\n' +
                    'Внутренняя отделка здания/помещения (площадью до 1 000 м2) на сумму 100 000 ₽\n' +
                    'Оконные стёкла, витрины, внутреннее остекление на сумму 50 000 ₽\n',
            },
        ],
        isSelected: true,
    },
    {
        tariff: 'life',
        title: TARIFFS_TRANSLATIONS_MAP.life,
        subtitle: 'Страхование жизни от несчастного случая и не только',
        tooltipText: 'Какая-то подсказка для большего понимания написанного в карточке',
        price: '100 000',
        listItems: [
            {
                text: 'Премия',
                price: '2 500',
                tooltip: 'Конструктивные элементы помещения (площадью до 1 000м2) на сумму 500 000 ₽\n' +
                    'Внутренняя отделка здания/помещения (площадью до 1 000 м2) на сумму 200 000 ₽\n' +
                    'Оконные стёкла, витрины, внутреннее остекление на сумму 100 000 ₽\n',
            },
        ],
      isSelected: false,
    },
];

export const PHONE_LENGTH = 11;

export const PERSON_PASSPORT_LENGTH = 10;

export const DEPARTMENT_CODE_LENGTH = 6;

export const MAX_QUERY_LENGTH = 255;
